import type { EndpointDefinition } from '@omnea-app/packages/backend/lambdalith/createOmneaApi'

export const requestEndpoints = {
  createRequest: { method: 'post', path: '/' },
  getRequestsPaginated: { method: 'post', path: '/paginated' },
  getRequestsPaginatedV2: { method: 'post', path: '/paginated-v2' },
  getRequest: { method: 'get', path: '/{id}' },
  deleteRequest: { method: 'post', path: '/{id}/delete' },
  prefillRequestForm: { method: 'get', path: '/{id}/request-form/{requestFormId}/prefill' },
  getRequestFormDiffValues: { method: 'get', path: '/{id}/request-form/{requestFormId}/diff-original-values' },
  bulkRequestFormSubmission: { method: 'post', path: '/{id}/bulk-request-form-submission' },
  createRequestFormSubmission: { method: 'post', path: '/{id}/request-form-submission' },
  autoSaveRequestFormSubmission: { method: 'post', path: '/{id}/request-form-submission-auto-save' },
  getResolvedNotificationMessage: { method: 'get', path: '/request-step/{requestStepId}/resolveNotificationMessage' },
  approveTask: { method: 'post', path: '/{id}/task/{taskId}/approve' },
  rejectTask: { method: 'post', path: '/{id}/task/{taskId}/reject' },
  uncompleteTask: { method: 'post', path: '/{id}/task/{taskId}/uncomplete' },
  getRequestSteps: { method: 'get', path: '/{id}/steps' },
  getRequestStepTaskErrors: { method: 'get', path: '/{id}/request-step-task-errors' },
  updateRequestProperties: { method: 'post', path: '/{id}/update-request-properties' },
  getRequestForm: { method: 'get', path: '/request-form/{requestFormId}' },
  getRequestFormParticipants: { method: 'get', path: '/request-form/{requestFormId}/participants' },
  getRequestForms: { method: 'get', path: '/request-forms/{requestId}' },
  getRequestStepAssignees: { method: 'get', path: '/step/assignees/{requestStepId}' },
  generateRequestName: { method: 'post', path: '/ai/generate-request-name' },
  getSupplierSteps: { method: 'get', path: '/supplier-steps' },
  getSupplierRequestForms: { method: 'get', path: '/{id}/supplier-request-forms/' },
  getRequestBlocksInfo: { method: 'get', path: '/{id}/request-blocks-info/' },
  pauseRequest: { method: 'post', path: '/{id}/pause' },
  resumeRequest: { method: 'post', path: '/{id}/resume' },
  insertPauseReason: { method: 'post', path: '/pause-reasons' },
  getPauseReasons: { method: 'get', path: '/pause-reasons' },
  rejectRequest: { method: 'post', path: '/{id}/reject' },
  unrejectRequest: { method: 'post', path: '/{id}/unreject' },
  getPauseDetail: { method: 'get', path: '/{id}/pause' },
  getRequestLeadsConfig: { method: 'get', path: '/leads-config' },
  addRequestLeads: { method: 'post', path: '/{id}/request-leads/add' },
  deleteRequestLead: { method: 'post', path: '/{id}/request-leads/delete' },
  getRequestAssignees: { method: 'get', path: '/{id}/assignees' },
  getRequestFollowers: { method: 'get', path: '/{id}/followers' },
  createRequestFollowers: { method: 'post', path: '/{id}/followers' },
  updateRequestFollower: { method: 'post', path: '/{id}/followers/{followerId}' },
  deleteRequestFollower: { method: 'post', path: '/{id}/followers/{followerId}/delete' },
  getRequestTabsData: { method: 'get', path: '/{id}/tabs-data' },
  getRequestStats: { method: 'get', path: '/get-stats' },
  duplicateRequest: { method: 'post', path: '/{id}/duplicate-request' },
  submissionAiSummaryFeedback: { method: 'post', path: '/submission-ai-summary/feedback' },
  evaluateRequestStepCondition: { method: 'get', path: '/{id}/request-step/{requestStepId}/condition-evaluation' },
  setBlockSkip: { method: 'post', path: '/{id}/blocks/{blockId}/skip' },
  updateBlockConfig: { method: 'post', path: '/{id}/blocks/{blockId}/update-block-config' },
  getUpdatableRequests: { method: 'get', path: '/workflows/{workflowId}/blocks/{blockId}/updatable-requests' },
  getChangeSummary: { method: 'get', path: '/{id}/request-form/{requestFormId}/change-summary' },
  getSavingsDashboard: { method: 'post', path: '/savings-dashboard' },
  getSavingsDashboardSummary: { method: 'get', path: '/savings-dashboard-summary' },
} as const satisfies Record<string, EndpointDefinition>
